import { useParams, Navigate } from 'react-router-dom'
import { useLesson } from '../../hooks/useApi'
import { useTelegramBackButton } from '../../hooks/useTelegramBackButton'
import { ContentRenderer, ImageSlider } from '../CardPage/components'
import type { ContentBlock } from '../../types/api'
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen'
import './LessonPage.css'

const LessonPage = () => {
  const { courseId, lessonId } = useParams<{ courseId: string; lessonId: string }>()
  const lessonIdNumber = lessonId ? parseInt(lessonId, 10) : null
  const { data, isLoading, error } = useLesson(lessonIdNumber)

  useTelegramBackButton(true)

  if (!lessonId || isNaN(lessonIdNumber!)) {
    return <Navigate to={courseId ? `/courses/${courseId}` : '/courses'} replace />
  }

  if (isLoading) {
    return <LoadingScreen isLoading={true} />
  }

  if (error) {
    const errorDetail = (error as any)?.response?.data?.detail

    return (
      <div className="lesson-page-error">
        <h2>Ошибка загрузки</h2>
        <p>{errorDetail || 'Не удалось загрузить урок'}</p>
        <button onClick={() => window.history.back()}>Вернуться назад</button>
      </div>
    )
  }

  if (!data?.lesson) {
    return (
      <div className="lesson-page-error">
        <h2>Урок не найден</h2>
        <button onClick={() => window.history.back()}>Вернуться назад</button>
      </div>
    )
  }

  const { lesson } = data
  const content = lesson.content

  return (
    <div className="lesson-page">
      {content.slider_images && content.slider_images.length > 0 && (
        <ImageSlider images={content.slider_images} title="" />
      )}

      <div className="lesson-page-content">
        {content.content && content.content.length > 0 && (
          <ContentRenderer content={content.content as ContentBlock[]} />
        )}
      </div>
    </div>
  )
}

export default LessonPage
